export const data = [
    {id: 1, name: "The Attic", city: "Cambridge", price: "$$", rating: 10, lat: 42.3725, long: -71.1161},
    {id: 2, name: "Found", city: "Cambridge", price: "$$", rating: 10, lat: 42.3640, long: -71.0998},
    {id: 3, name: "Great Eastern Trading Co", city: "Cambridge", price: "$$", rating: 8, lat: 42.3647, long: -71.1067},
    {id: 4, name: "Friends + Family", city: "Cambridge", price: "$$$", rating: 7, lat: 42.3653, long: -71.1032},
    {id: 5, name: "Retrospect", city: "Cambridge", price: "$$", rating: 6, lat: 42.3688, long: -71.1095}
];